import { Flex, Text, TextField, Button } from "@radix-ui/themes";
import { useOIDCValidation } from "../../hooks/useOIDCValidation";
import styles from "./Drawer.module.scss";

export type OIDCField = "oidcClientId" | "oidcAuthority" | "oidcAudience";

interface OIDCConfigurationFieldsProps {
  oidcClientId?: string;
  oidcAuthority?: string;
  oidcAudience?: string;
  onChange: (field: OIDCField, value: string) => void;
}

export const OIDCConfigurationFields = ({
  oidcClientId,
  oidcAuthority,
  oidcAudience,
  onChange,
}: OIDCConfigurationFieldsProps) => {
  const {
    validationStatus,
    validationMessage,
    validateConfiguration,
    resetValidation,
  } = useOIDCValidation();

  const handleFieldChange = (field: OIDCField, value: string) => {
    onChange(field, value);
    if (validationStatus !== "idle") {
      resetValidation();
    }
  };

  return (
    <Flex direction="column" gap="4">
      <Flex direction="column" gap="1">
        <Text className={styles.label}>OIDC Client ID <Text as="span" color="red">*</Text></Text>
        <TextField.Root
          value={oidcClientId || ""}
          onChange={(e) => handleFieldChange("oidcClientId", e.target.value)}
          variant="soft"
          color="gray"
        />
      </Flex>

      <Flex direction="column" gap="1">
        <Text className={styles.label}>OIDC Authority <Text as="span" color="red">*</Text></Text>
        <TextField.Root
          value={oidcAuthority || ""}
          onChange={(e) => handleFieldChange("oidcAuthority", e.target.value)}
          variant="soft"
          color="gray"
        />
      </Flex>

      <Flex direction="column" gap="1">
        <Text className={styles.label}>OIDC Audience <Text as="span" color="gray" size="1">(Optional)</Text></Text>
        <TextField.Root
          value={oidcAudience || ""}
          onChange={(e) => handleFieldChange("oidcAudience", e.target.value)}
          variant="soft"
          color="gray"
        />
      </Flex>

      <Flex direction="column" gap="2">
        <Button
          variant="outline"
          color="gray"
          onClick={() => validateConfiguration(oidcAuthority)}
          disabled={
            validationStatus === "loading" ||
            !oidcAuthority ||
            validationStatus === "success"
          }
          style={{ width: "100%" }}
        >
          {validationStatus === "loading"
            ? "Validating..."
            : "Validate Authority"}
        </Button>
        {validationMessage && (
          <Text
            size="1"
            color={
              validationStatus === "success"
                ? "green"
                : validationStatus === "error"
                ? "red"
                : "gray"
            }
          >
            {validationMessage}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
